// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EgwF","tabsBox":"styles_tabsBox__2MXLn","createButton":"styles_createButton__3ns_-"};